<script>
import { uploadPhotoIcon, crossIcon } from "@/utils/proposalIcons";
import { processImageUpload } from "@/utils/imageUpload";
import {api_baseURL} from "@/utils/init.js";
import blankPng from "@/assets/blank.png";

export default {
    name: "PhotoBox",
    props: {
        project: { type: Object, required: true },
        type: { type: String, default: "projects" },
        index: { type: Number, default: 0 },
        width: { type: String, default: "100%" },
        height: { type: String, default: "100%" },
        bgColor: { type: String, default: "white" },
        objectFit: { type: String, default: "fill" },
        position: { type: String, default: "center" }
    },
    data() {
        return {
            localImage: null,
            hasUpload: false,
            uploadPhotoIcon,
            crossIcon,
			d_isBlankPng: this.project.fileName?.endsWith('blank.png'),
        };
    },
	created() {},
	async mounted() {
	    this.localImage = await this.getImage();
	   
	},
    computed: {
        watchSources() {
            return [
                this.project.clientLogo,
                this.project.logo,
                this.project.uploadedProfilePicture,
                this.project.profilePicturePath,
                this.project.uploadedPhoto,
                this.project.photoURL,
                this.project.projectPhotos,
                this.project.projectPhotos && this.project.projectPhotos[this.index]
            ];
        }
    },
    watch: {

  watchSources: {
    handler: async function () {
      this.localImage = await this.getImage();
    },
    deep: true,
    immediate: true
    },
    project:{
		    async handler() {this.localImage = await this.getImage();
			},
		    deep: true,
            immediate: true
		}
    },
    methods: {
     async getImage() {
   
	
	 if (this.project.fileName) {
            return `${api_baseURL}proposalFile?fileName=${encodeURIComponent(this.project.fileName)}`;
        }
	

    // --- CLIENT LOGO ---
    if (this.type === "clientLogo") {
        return this.project.uploadedClientLogo 
            || this.project.clientLogo 
            || null;
    }

    // --- COMPANY LOGO ---
    if (this.type === "logo") {
        return this.project.uploadedLogo 
            || this.project.logo 
            || null;
    }

    // --- PROFILE PICTURE ---
    if (this.type === "profile") {
        if (this.project.uploadedProfilePicture) {
            return this.project.uploadedProfilePicture;
        }
        if (this.project.profilePicturePath) {
            return `${api_baseURL}profilePicture?tmid=${this.project.teamMemberId}`;
        }
        return null;
    }

    // --- MAIN PROJECT PHOTO (index 0) ---
    if (this.index === 0) {
	
        const url = await this.$store.dispatch(
            'getPhotoURL',
            this.project.projectId
        );


        // Prefer uploaded → hydrated → fetched
        return (
            this.project.uploadedPhoto ||
            this.project.photoURL ||
            url ||
            null
        );
    }

    // --- ADDITIONAL PROJECT PHOTOS (index > 0) ---
     return (
        this.project.projectPhotos?.[this.index] ||
        null
       );
     
    },

        triggerUpload() {
            this.$refs.fileInput.click();
        },
   async handleUpload(e) {
            const file = e.target.files[0];
			let fileName  = "";
			
			//---Delete existing file first.
			if (this.project.fileName) {
				fileName = this.project.fileName;
				delete this.project.fileName;
                this.localImage = null;
				await this.$store.dispatch("deleteProposalFile", { fileName });
				}
			
            if (file) {
                try {
				    const proposalFileId=Date.now() + Math.random();
				    fileName= await this.$store.dispatch("uploadProposalFile", {files: [file], proposalFileId: proposalFileId});
					this.project.fileName=fileName;
					const base64 = await processImageUpload(file);
					
                   
                    if (this.type === "clientLogo") {
                        this.project.uploadedClientLogo = base64;
                    } else if (this.type === "logo") {
                        this.project.uploadedLogo = base64;
                    } else if (this.type === "profile") {
                        this.project.uploadedProfilePicture = base64;
                    } else if (this.index === 0) {
                        this.project.uploadedPhoto = base64;
                    } else {
                        if (!this.project.projectPhotos) {
                            this.project.projectPhotos = [null, null, null, null];
                        }
                        this.project.projectPhotos[this.index] = base64;
                        this.project.projectPhotos = [...this.project.projectPhotos];
                    }
                    this.localImage = base64;
                    this.hasUpload = true;
                } catch (error) {
                    console.error("Image upload failed:", error);
                }
                e.target.value = '';
            }
        },
async handleRemove() {
    // If a server file exists, delete it properly
    if (this.project.fileName) {
        const fileName = this.project.fileName;   // store before deleting
        delete this.project.fileName;
        this.localImage = null;

        // delete the server file
        await this.$store.dispatch("deleteProposalFile", { fileName });
    }

    // Replace with blank.png
    await this.m_uploadBlankImage();
},
  async m_checkBlankPng(src) {
    let hashHex = null;
    try {
        // If it's a base64 string
        if (src.startsWith("data:image")) {
            const base64 = src.split(",")[1];
            const buffer = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
            hashHex = await this.m_hashBuffer(buffer);
			return hashHex === this.d_blankPng;
        }

        // If it's a URL (server file)
		console.log('fileName', this.project.fileName);
        const response = await this.$store.dispatch("getProposalFile", this.project.fileName);
        const arrayBuffer = await response.arrayBuffer();
        hashHex = await this.m_hashBuffer(new Uint8Array(arrayBuffer));
		console.log('hashHex', hashHex);
		return hashHex === this.d_blankPng;

    } catch (err) {
        console.error("Blank PNG check failed:", err);
        return false;
    }
},
async m_hashBuffer(buffer) {
    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
	console.log('hashHex',hashHex);
	console.log(this.d_blankPng);

    return hashHex === this.d_blankPng;
},
async m_uploadBlankImage() {
    const response = await fetch(blankPng);
    const blob = await response.blob();
    const file = new File([blob], "blank.png", { type: "image/png" });

    const proposalFileId = Date.now() + Math.random();
    const fileName = await this.$store.dispatch("uploadProposalFile", {
        files: [file],
        proposalFileId
    });

    this.project.fileName = fileName;
    this.localImage = blankPng;
    this.d_isBlankPng = true;
}

  }
};
</script>

<template>
    <div class="photo-box-wrapper" :style="{
        width: width,
        height: height,
        backgroundColor: bgColor,
    }">
        <div class="image-container" :class="{ 'contain-mode': objectFit === 'contain' }">
            <img v-if="localImage" :key="localImage" :src="localImage" :style="{ objectFit: objectFit }"
                alt="Photo" />
            <div v-else-if="type === 'profile'" class="pictureBox">
                <div class="head" />
                <div class="body" />
            </div>

            <div class="photo-overlay" :class="position">
                <button class="overlay-btn" @click.stop="triggerUpload" title="Upload">
                    <span v-html="uploadPhotoIcon" />
                </button>
                <button  v-if="!d_isBlankPng" class="overlay-btn remove" @click.stop="handleRemove" title="Remove">
                    <span v-html="crossIcon" />
                </button>
            </div>
        </div>

        <input type="file" ref="fileInput" @change="handleUpload" accept="image/*" class="d-none" />
    </div>
</template>


<style scoped lang="scss">
.photo-box-wrapper {
    position: relative;
    overflow: hidden;

    .image-container {
        position: relative;
        width: 100%;
        height: 100%;

        &:hover {
            .photo-overlay {
                opacity: 1;
            }

            img {
                opacity: 0.9;
            }
        }

        img {
            width: 100%;
            height: 100%;
        }

        &.contain-mode {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
        }

        .pictureBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
            height: 100%;
            background: #f0f0f0;

            .head {
                background: white;
                width: 30%;
                height: 30%;
                border-radius: 50%;
                margin-bottom: 2%;
            }

            .body {
                background: white;
                width: 60%;
                height: 40%;
                border-top-left-radius: 50%;
                border-top-right-radius: 50%;
            }
        }
    }

    .photo-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        gap: 10px;
        opacity: 0;
        transition: opacity 0.2s;
        z-index: 10;
        padding: 10px;

        &.center {
            align-items: center;
            justify-content: center;
        }

        &.top-left {
            align-items: flex-start;
            justify-content: flex-start;
        }

        &.top-right {
            align-items: flex-start;
            justify-content: flex-end;
        }

        &.top-center {
            align-items: flex-start;
            justify-content: center;
        }

        &.bottom-left {
            align-items: flex-end;
            justify-content: flex-start;
        }

        &.bottom-right {
            align-items: flex-end;
            justify-content: flex-end;
        }

        &.bottom-center {
            align-items: flex-end;
            justify-content: center;
        }

        .overlay-btn {
            background: rgba(255, 255, 255, 0.5);
            border: none;
            border-radius: 50%;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
            transition: transform 0.2s;
            color: #333;

            &:hover {
                transform: scale(1.1);
                color: #4475b4;
                background: #e8eff7;
            }

            &.remove {
                &:hover {
                    color: #ef4444;
                    background: #feeded;
                }
            }
        }
    }
}
</style>
